export enum ContractVariableSourceEnum {
  LEAD = 'LEAD',
  LEAD_LEGAL = 'LEAD_LEGAL',
  CONTRACTOR = 'CONTRACTOR',
  SERVICE = 'SERVICE',
  PAYMENT = 'PAYMENT',
  ISSUANCE = 'ISSUANCE',
  CUSTOM = 'CUSTOM',
}
